import axiosInstance from "./axiosInstance";

export async function getAllAPNodes() {
  try {
    const response = await axiosInstance.get("/ap");
    if (response.status === 200) {
      return response;
    }
    throw response;
  } catch (error) {
    throw error;
  }
}

export async function getCategories() {
  try {
    const response = await axiosInstance.get("/ap/category");
    if (response.status === 200) {
      return response;
    }
    throw response;
  } catch (error) {
    throw error;
  }
}

export async function validateLicense(license) {
  try {
    const response = await axiosInstance.get(`/ap/validate/license/${license}`);
    if (response.status === 200) {
      return response;
    }
    throw response;
  } catch (error) {
    throw error;
  }
}

export async function saveAccessPoint(apInfo, license) {
  try {
    const response = await axiosInstance.post(`/ap/update/${license}`, apInfo, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    if (response.status === 200) {
      return response;
    }
    throw response;
  } catch (error) {
    throw error;
  }
}

export async function editAccessPoint(apInfo, id) {
  try {
    const response = await axiosInstance.put(`/ap/update/${id}`, apInfo, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    // Check for multiple success status codes
    if ([200, 202, 204].includes(response.status)) {
      return response;
    }
    throw response;
  } catch (error) {
    throw error;
  }
}

export async function saveBlockCategories(apInfo) {
  try {
    const response = await axiosInstance.post(`/ap/restriction`, apInfo, {});
    if (response.status === 200) {
      return response;
    }
    throw response;
  } catch (error) {
    throw error;
  }
}
